import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  firstName: '',
  lastName: '',
  email: '',
  phoneNr: '',
  persNr: '',
  role: '',
  auth: '',
  flag: '',
  id: '',
};

export const adduserSlice = createSlice({
  name: 'adduser',
  initialState,
  reducers: {
    setAdduser(state, { payload }) {
      state.firstName = payload.firstName;
      state.lastName = payload.lastName;
      state.email = payload.email;
      state.phoneNr = payload.phoneNr;
      state.persNr = payload.persNr;
      state.role = payload.role;
      state.auth = payload.auth;
      state.flag = payload.flag;
      state.id = payload.id;
    },
  },
});

export const { setAdduser } = adduserSlice.actions;
export default adduserSlice.reducer;
